import AuthShell from "@/components/landing/auth/AuthShell";
import { useState } from "react";

export default function ComingSoonBody() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  function onSubmit(event) {
    event.preventDefault();
    setSubscribed(true);
  }

  return (
    <AuthShell
      className="coming-soon"
      title="Coming soon"
      subtitle="This feature is almost ready. Join the waitlist for updates.">
      <form onSubmit={onSubmit}>
        <div className="single-input">
          <input
            type="email"
            placeholder="Enter your email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        {subscribed ? (
          <p className="text-success small mb-3">
            Thanks, you&apos;re on the list. We&apos;ll notify you soon.
          </p>
        ) : null}
        <div className="btn-area mt-0 mb-0">
          <button className="cmn-btn" type="submit">
            Notify me
          </button>
        </div>
      </form>
    </AuthShell>
  );
}
